module.exports = __webpack_public_path__ + "img/appltCourse-img36.8ae58949.png";